/**
 * Layout do CCO: cabeçalho (abas, contadores de alarme ISA-101, estado do tempo real) e gaveta do assistente — Nexora Grid.
 *
 * Criado em: 16/10/2026 · Última modificação: 01/11/2026 · Versão: 2.6.0
 *
 * US-402 · documento 13 §6.1 e §11.3.
 * v1.6 (GUS-1501): o assistente virou gaveta sobreposta, disponível em todas as telas do CCO.
 * v2.0 (GUS-1508, decisão de 18/10/2026): a tela antiga (N1 com blocos grandes, N2 por grupos, N3 e N4 separados) sai.
 *   A visão geral e os níveis cidade → setor → equipamento → diagnóstico são a tela nova (`CcoNovo.tsx`, protótipo
 *   aprovado v4). As tendências do Grafana ganharam aba própria (`Tendencias.tsx`, GUS-1509).
 * D-010: nomes das áreas pela fonte única `nomes.ts` (o nome do menu é o padrão do sistema).
 * v2.4 (US-3804): aba "Local" (constelação 3D de pessoas e agentes), só com `ver_observabilidade_local`.
 * v2.5 (US-4402): aba "Mapa de Comando" (maquete 3D viva da rede), só com `ver_observabilidade_local`.
 * v2.6 (Sprint 44): a aba "Local" (constelação 3D, US-3804) foi retirada; o Mapa de Comando a substitui.
 */
import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import { CAMINHO_CCO_NOVO, CcoNovo } from "./CcoNovo";
import { ProvedorCco, useCco } from "./contexto";
import { Assistente } from "./Assistente";
import { FORMA, NOME_PRIORIDADE, type Prioridade } from "./medidas";
import { NOMES } from "../nomes";
import { pode } from "../permissoes";
import { useSessao } from "../sessao";

export function Cco() {
  const { pathname } = useLocation();
  return (
    <ProvedorCco>
      <CabecalhoCco />
      {/* a tela nova fica montada entre os níveis (o voo e o estado não se perdem ao trocar de rota) */}
      {CAMINHO_CCO_NOVO.test(pathname) ? <CcoNovo /> : <Outlet />}
      <Assistente />
    </ProvedorCco>
  );
}

function CabecalhoCco() {
  const { vivo, contagem } = useCco();
  const { usuario } = useSessao();
  return (
    <header className="cabecalho-cco">
      <nav className="sub-abas" aria-label="CCO">
        <NavLink to="/cco" end>{NOMES.visaoGeral}</NavLink>
        <NavLink to="/cco/tendencias">{NOMES.tendencias}</NavLink>
        <NavLink to="/cco/alarmes">{NOMES.alarmes}</NavLink>
        <NavLink to="/cco/analise">{NOMES.analise}</NavLink>
        <NavLink to="/cco/relatorios">{NOMES.relatorios}</NavLink>
        <NavLink to="/cco/qualidade">{NOMES.qualidade}</NavLink>
        <NavLink to="/cco/gestor">{NOMES.gestor}</NavLink>
        {usuario && pode.verObservabilidadeLocal(usuario) && <NavLink to="/cco/mapa">{NOMES.mapaComando}</NavLink>}
        <NavLink to="/cco/seguranca">{NOMES.seguranca}</NavLink>
      </nav>
      <span className="espaco" />
      {([1, 2, 3, 4] as Prioridade[]).map((p) => (
        <Link key={p} to="/cco/alarmes" className={`contador-alarme prioridade-${p}`} title={`alarmes ${NOME_PRIORIDADE[p]} (24 h)`}>
          <span className="forma">{FORMA[p]}</span> {contagem[String(p)] ?? 0}
        </Link>
      ))}
      <span className={`conexao ${vivo.conectado ? "on" : "off"}`} role="status">
        {vivo.conectado ? `ao vivo · ${vivo.atualizadoEm?.toLocaleTimeString("pt-BR") ?? ""}` : "reconectando…"}
      </span>
    </header>
  );
}
